// extracted by mini-css-extract-plugin
export default {"root":"RestrictionBlock-root_i8zbl"};